/**
 * 主入口
 */
import { getUrlArg } from "../urlUtil";
import { getCurrPlat } from "@utils/plat";
import envi from "../envi";
import { getPlatformModule } from "./import";

/**
 * 平台api
 */
const platform = getPlatformModule({
    /**
     * 拦截auth处理
     * @param {Promise<Record<string, unknown>} resolve 结果异步
     * @returns
     */
    getAuth(resolve) {
        // 获取refid
        const refid = getUrlArg("refid") || getUrlArg("refid", true) || "1000";
        // 拼接参数
        return resolve.then(res => ({
            ...res,
            refid,
            platId: getCurrPlat().id
        }));
    },
    /**
     * 拦截分享
     * @param {Promise<Record<string, unknown>} returnValue 结果
     * @returns
     */
    share(returnValue) {
        return returnValue || Promise.reject();
    },
    /**
     * 判断是否是app
     * @returns {boolean} 是否为app
     */
    isInApp() {
        return envi.isInApp;
    },
    /**
     * 判断是否是微信
     * @returns {boolean} 是否为微信
     */
    isInWechat() {
        return envi.isInWeixin;
    }
});
export default platform;
